window.addEventListener("DOMContentLoaded", () => {

    window.diableSUbscritionSelectionOnBundleItems = debounce(function () {
        const items = Array.from(document.querySelectorAll('.upcart-product-item'));

        const bundleItems = items.filter(item => item.innerHTML.includes('_belongs_to_bundle'));
        setTimeout(() => {
            bundleItems.forEach(item => {
                const subSelector = item.querySelector('.upcart-subscription-upgrade-section');
                const quantitySelector = item.querySelector('.styles_QuantityField__');

                if (subSelector) {
                    subSelector.style.opacity = .5;
                    subSelector.style.pointerEvents = 'none';
                }
                if (quantitySelector) {
                    quantitySelector.style.opacity = .5;
                    quantitySelector.style.pointerEvents = 'none';
                }
            })
        }, 1000)
    }, 500)

    diableSUbscritionSelectionOnBundleItems();

    // Observe cart changes to disable subscription selector on bundles
    const targetNode = document.querySelector('.upcart-cart-body');

    if (targetNode) {

        const config = { childList: true, subtree: true };

        const callback = function (mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    diableSUbscritionSelectionOnBundleItems();
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

});